export const emmaWalkthroughData = {
    icon: 'emma',
    title: 'Emma app',
    subtitle: 'Learn about the Emma app by following an initial walkthrough',
};
export const investWalkthroughData = {
    icon: 'invest',
    title: 'Emma Invest',
    subtitle: 'Learn about Emma Invest by following an initial walkthrough',
};
